import { Box, Link, Typography } from '@mui/material'
import { paths } from 'app/routes/paths'
import notFoundCodeSrc from 'assets/images/404-code.svg'
import serverErrorCode from 'assets/images/500-code.svg'
import pageNotFoundSrc from 'assets/images/page-not-found.svg'
import serverErrorSrc from 'assets/images/server-error.svg'
import { GeneralToolbar } from 'components/toolbar'
import { Button } from 'elements/inputs/button'
import { useTranslation } from 'react-i18next'

type ErrorVariant = 'NOT_FOUND' | 'SERVER_ERROR' | 'OTHER'

const getErrorDetails = (variant: ErrorVariant) => {
  switch (variant) {
    case 'NOT_FOUND': {
      return {
        imageSrc: pageNotFoundSrc,
        errorCodeSrc: notFoundCodeSrc,
        title: 'common.page_not_found',
        subtitle: 'common.page_does_not_exist',
      }
    }

    case 'SERVER_ERROR': {
      return {
        imageSrc: serverErrorSrc,
        errorCodeSrc: serverErrorCode,
        title: 'common.something_went_wrong',
        subtitle: 'common.we_are_working_on_fixing_problem',
      }
    }

    case 'OTHER': {
      return {
        imageSrc: pageNotFoundSrc,
        title: 'common.something_went_wrong',
        subtitle: 'common.we_are_working_on_fixing_problem',
      }
    }
  }
}

const ErrorPage = ({ variant }: { variant: ErrorVariant }) => {
  const { t } = useTranslation()

  const { imageSrc, title, subtitle, errorCodeSrc } = getErrorDetails(variant)

  return (
    <>
      {variant === 'NOT_FOUND' && <GeneralToolbar />}

      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <Box component="img" src={imageSrc} width="25%" mt={8} />

        <Box
          sx={{
            width: '45%',
            pl: 8.5,
            pt: 12.5,
            backgroundImage: `url(${errorCodeSrc})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top right',
            backgroundSize: '100%',
          }}
        >
          <Typography fontSize="40px" fontWeight={600}>
            {t('common.oops')}
          </Typography>
          <Typography fontSize="40px" fontWeight={600} mb={1}>
            {t(title)}
          </Typography>
          <Typography fontSize="24px" mb={4} maxWidth={488}>
            {t(subtitle)}
          </Typography>

          {variant === 'NOT_FOUND' ? (
            <Button component={Link} href={paths.projects}>
              {t('common.back_to_projects')}
            </Button>
          ) : (
            <Button onClick={() => location.reload()}>
              {t('common.refresh_page')}
            </Button>
          )}
        </Box>
      </Box>
    </>
  )
}

export default ErrorPage
